import { apiCall } from './gqlClient';

const ALIGNCODA_QUERY = `
  mutation alignCoda($providerId: Int!) {
    alignCoda(providerId: $providerId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const alignCodaApiCall = async ({providerId}, fragments = null) => apiCall({ query: ALIGNCODA_QUERY, variables: {providerId}, fragments });
